/**
 * @module support/payment-options
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const PAYMENT_OPTIONS = {
  PAYMENT_OPTIONS_MODULE: 'PaymentOptionsModule',
  PAYMENT_OPTIONS_COMPONENT: 'PaymentOptionsComponent',
  SUPPORT_ORDER_PAYMENT_SERVICE: 'SupportOrderPaymentService',
  CASH: 'cash',
  CC: 'CC',
  CREDIT: 'Credit',
  DEBIT: 'Debit',
};
